import { Outlet, createFileRoute } from '@tanstack/react-router'

import { StudentAppNavigationTabsMyLearning } from '@/app/student/StudentAppNavigationTabsMyLearning'
import StudentAppPagePadding from '@/app/student/StudentAppPagePadding'
import DashboardPage from '@/dashboard/components/DashboardPage/DashboardPage'

export const Route = createFileRoute('/_learning/_my-learning')({
  component: MyLearningLayout,
})

function MyLearningLayout() {
  return (
    <StudentAppNavigationTabsMyLearning>
      <DashboardPage>
        <StudentAppPagePadding>
          <Outlet />
        </StudentAppPagePadding>
      </DashboardPage>
    </StudentAppNavigationTabsMyLearning>
  )
}
